import AdminMovieCard from './AdminMovieCard';

export default AdminMovieCard;
